/*
 * TeamGroupList Messages
 *
 * This contains all the text for the TeamGroupList component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.TeamGroupList';

export default defineMessages({
  createSuccess: {
    id: `${scope}.createSuccess`,
    defaultMessage: 'Group is created successfully',
  },
  updateSuccess: {
    id: `${scope}.updateSuccess`,
    defaultMessage: 'Group is updated successfully',
  },
  deleteSuccess: {
    id: `${scope}.deleteSuccess`,
    defaultMessage: 'Group is deleted successfully',
  },
  firstToAdd: {
    id: `${scope}.firstToAdd`,
    defaultMessage: 'Be first to add team group',
  },
  create: {
    id: `${scope}.create`,
    defaultMessage: 'Create group',
  },
  update: {
    id: `${scope}.update`,
    defaultMessage: 'Update group',
  },
});
